const initialState = {
  detail: {},
  escrowDetails: {},
  fetchClaimAllPending:false,
  fetchClaimRewardPending:false
};

export default initialState;
